// Nasus — Siphoning Strike: A powerful physical blow that draws strength from
// slain enemies. Stack bonus is baked into baseAd via RunState.nasusStacks.

import { physicalDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const nasusSiphoning: Ability = {
  id: "nasusSiphoning",
  displayName: "Siphoning Strike",
  description: "Slams with a golden axe for 1.7× AD + 40 and heals for 10% of damage dealt. Grows stronger permanently for every enemy slain.",
  iconId: "NasusQ",

  targetShape({ caster, combat }) {
    const team = caster.team === "player" ? "enemy" : "player";
    const front = combat.livingUnitsOf(team).sort((a, b) => a.pos.q - b.pos.q)[0];
    return front ? [front.pos] : [caster.pos];
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const team = caster.team === "player" ? "enemy" : "player";
    const target = combat.livingUnitsOf(team).sort((a, b) => a.pos.q - b.pos.q)[0];
    if (!target) return [];
    const stats = effectiveStats(caster);
    const damage = physicalDamage(stats.ad * 1.7 + 40);
    const heal = Math.round(damage * 0.1);
    return [
      { target, amount: damage, type: "physical", nasusAxe: true },
      { target: caster, amount: 0, type: "none", heal },
    ];
  },
};
